<div class="flag-subscription-modal">
  <div class="modal-header">
    <button
      aria-label="Close"
      class="close"
      data-dismiss="modal"
      type="button"
      (click)="handleModalHide()"
    >
      <span aria-hidden="true"> × </span>
    </button>
  </div>
  <div class="modal-body">
    <div class="info">
      <h3>Reason of {{ actionLabel }}</h3>
    </div>
    <form [formGroup]="flaggingForm" (ngSubmit)="onContinueEvent()">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="form-control-label required" for="flagging-reason">
              {{ actionLabel }} Reason
            </label>
            <input
              type="text"
              formControlName="flaggingReason"
              id="flagging-reason"
              name="flagging-reason"
              class="input form-control"
              placeholder="{{ actionLabel  }} Reason"
            />
          </div>
        </div>
      </div>
      <div class="actions">
        <button class="btn action-btn back-btn" type="button" (click)="handleModalHide()">
          Cancel
        </button>
        <button class="btn action-btn continue-btn" type="submit" [disabled]="checkSubmitDisable()">
          Submit
        </button>
      </div>
    </form>
  </div>
</div>
